import './App.css';
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useGlobalContext } from "./Context"
import Navbar from './Components/Navbar';
import AppRouter from './AppRouter'
import { Layout, theme } from 'antd';
import NaviBreadcrumb from './Components/NaviBreadcrumb';

const { Header, Content, Footer } = Layout;

const App = () => {
  const currentLocation = useLocation();
  const { clearSaveSearchTerm } = useGlobalContext();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  useEffect(() => {
    if (currentLocation.pathname === "/")
      clearSaveSearchTerm();

  }, [currentLocation]);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Navbar />
      </Header>
      <Content
        style={{
          padding: '0 48px',
        }}
      >
        <NaviBreadcrumb />
        <div
          style={{
            margin: '16px 0',
            padding: 24,
            minHeight: 'calc(100vh - 112px)',
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <AppRouter />
        </div>
      </Content>
      <Footer
        style={{
          textAlign: 'center',
        }}
      >
        Foodgrade New Zealand - {new Date().getFullYear()}
      </Footer>
    </Layout>
  );
};


export default App;





